import { UserContext } from 'libs/contexts';
import { useContext } from 'react';
import { UserSource, ROLE_TYPE } from 'libs/enums';

const IsExternalPurchaserUsed = () => {
  const userInfo = useContext(UserContext);
  if (!userInfo) return false;
  return (
    userInfo.applications[0].key === ROLE_TYPE.PURCHASER &&
    userInfo.organizationSource === UserSource.outside
  );
};

export default IsExternalPurchaserUsed;
